import { useDispatch, useSelector } from "react-redux";
import * as paymentActions from "_redux/actions/payment";
import { useCallback } from "react";

export const usePaymentStore = () => {
  const dispatch = useDispatch();

  const _payment = useSelector((store) => store.payment);

  const fetchWallet = useCallback(
    (user) => dispatch(paymentActions.fetchWallet(user)),
    [dispatch]
  );

  const clearWalletStatus = useCallback(
    () => dispatch(paymentActions.clearWalletStatus()),
    [dispatch]
  );

  const fetchTransactions = useCallback(
    (user) => dispatch(paymentActions.fetchTransactions(user)),
    [dispatch]
  );

  const clearTransactionsStatus = useCallback(
    () => dispatch(paymentActions.clearTransactionsStatus()),
    [dispatch]
  );

  const initiateStkPush = useCallback(
    (initiateStkPushDetails) =>
      dispatch(paymentActions.initiateStkPush(initiateStkPushDetails)),
    [dispatch]
  );

  const clearInitiateStkPushStatus = useCallback(
    () => dispatch(paymentActions.clearInitiateStkPushStatus()),
    [dispatch]
  );

  const withdraw = useCallback(
    (withdrawDetails) => dispatch(paymentActions.withdraw(withdrawDetails)),
    [dispatch]
  );

  const clearWithdrawStatus = useCallback(
    () => dispatch(paymentActions.clearWithdrawStatus()),
    [dispatch]
  );

  const fetchExchangeRate = useCallback(
    (exchangeRateDetails) =>
      dispatch(paymentActions.fetchExchangeRate(exchangeRateDetails)),
    [dispatch]
  );

  const clearExchangeRateStatus = useCallback(
    () => dispatch(paymentActions.clearExchangeRateStatus()),
    [dispatch]
  );

  const transfers = useCallback(
    (transfersDetails) => dispatch(paymentActions.transfers(transfersDetails)),
    [dispatch]
  );

  const clearTransfersStatus = useCallback(
    () => dispatch(paymentActions.clearTransfersStatus()),
    [dispatch]
  );

  const initiateCardPayment = useCallback(
    (initiateCardPaymentDetails) =>
      dispatch(paymentActions.initiateCardPayment(initiateCardPaymentDetails)),
    [dispatch]
  );

  const clearInitiateCardPaymentStatusAndDetails = useCallback(
    () => dispatch(paymentActions.clearInitiateCardPaymentStatusAndDetails()),
    [dispatch]
  );

  const initiateBankTransfer = useCallback(
    (initiateBankTransferDetails) =>
      dispatch(
        paymentActions.initiateBankTransfer(initiateBankTransferDetails)
      ),
    [dispatch]
  );

  const clearInitiateBankTransferStatus = useCallback(
    () => dispatch(paymentActions.clearInitiateBankTransferStatus()),
    [dispatch]
  );

  const initiateMerchantPayment = useCallback(
    (initiateMerchantPaymentDetails) =>
      dispatch(
        paymentActions.initiateMerchantPayment(initiateMerchantPaymentDetails)
      ),
    [dispatch]
  );

  const clearInitiateMerchantPaymentStatus = useCallback(
    () => dispatch(paymentActions.clearInitiateMerchantPaymentStatus()),
    [dispatch]
  );

  const fetchPaymentTransaction = useCallback(
    (uniqueRequestId) =>
      dispatch(paymentActions.fetchPaymentTransaction(uniqueRequestId)),
    [dispatch]
  );

  const clearFetchPaymentTransactionStatus = useCallback(
    () => dispatch(paymentActions.clearFetchPaymentTransactionStatus()),
    [dispatch]
  );

  const initiateCashiaWithdrawal = useCallback(
    (initiateCashiaWithdrawalDetails) =>
      dispatch(
        paymentActions.initiateCashiaWithdrawal(
          initiateCashiaWithdrawalDetails
        )
      ),
    [dispatch]
  );

  const clearInitiateCashiaWithdrawalStatus = useCallback(
    () => dispatch(paymentActions.clearInitiateCashiaWithdrawalStatus()),
    [dispatch]
  );

  return {
    payment: _payment,
    fetchWallet,
    clearWalletStatus,
    fetchTransactions,
    clearTransactionsStatus,
    initiateStkPush,
    clearInitiateStkPushStatus,
    withdraw,
    clearWithdrawStatus,
    fetchExchangeRate,
    clearExchangeRateStatus,
    transfers,
    clearTransfersStatus,
    initiateCardPayment,
    clearInitiateCardPaymentStatusAndDetails,
    initiateBankTransfer,
    clearInitiateBankTransferStatus,
    initiateMerchantPayment,
    clearInitiateMerchantPaymentStatus,
    fetchPaymentTransaction,
    clearFetchPaymentTransactionStatus,
    initiateCashiaWithdrawal,
    clearInitiateCashiaWithdrawalStatus,
  };
};
